import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginSuccessScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 1500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0B0C] p-4">
      <div className="text-center space-y-4">
        <div className="text-5xl">✓</div>
        <h1 className="playfair text-3xl text-white">Login successful</h1>
        <p className="text-[#A8A29E]">Redirecting to Home</p>
      </div>
    </div>
  );
};

export default LoginSuccessScreen;
